var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M59.2 14.1571V12.1429C59.2 10.9571 58.2429 10 57.0571 10H2.14286C0.957143 10 0 10.9571 0 12.1429V46.5429C0 47.7286 0.957143 48.6857 2.14286 48.6857H57.0571C58.2429 48.6857 59.2 47.7286 59.2 46.5429V14.1571ZM52.9286 14.2857L29.5857 29.6L5.9 14.2857H52.9286ZM4.28571 44.4V18.3429L28.4286 33.9571C28.7857 34.1857 29.1857 34.3 29.5857 34.3C29.9857 34.3 30.4 34.1857 30.7571 33.9429L54.9143 18.1V44.4H4.28571Z","fill":"#0FB761"}));
}

Email.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = Email;

Email.default = Email;
